import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Download, FileSpreadsheet } from "lucide-react";
import { useGolfData } from "./golf/hooks/useGolfData";
import { GolfTable } from "./golf/GolfTable";
import { exportToCSV, exportToExcel } from "../utils/exportData";
import { format } from "date-fns";
import { fr } from "date-fns/locale";

export const GolfTab = () => {
  const { registrations, isLoading, error } = useGolfData();

  const formatForExport = () =>
    registrations.map((r) => ({
      Nom: r.last_name,
      Prénom: r.first_name,
      Email: r.email,
      Téléphone: r.phone || "",
      Index: r.golf_index,
      "Statut paiement": r.payment_status,
      "Date de création": format(new Date(r.created_at), "dd/MM/yyyy", { locale: fr }),
      Coéquipier: r.teammate || "",
      Montant: r.amount || 0,
      "Don additionnel": r.additional_donation || 0,
    }));

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between">
        <CardTitle>Inscriptions Golf ({registrations.length})</CardTitle>
        <div className="flex gap-2">
          <Button
            variant="outline"
            size="sm"
            onClick={() => exportToCSV(formatForExport(), "inscriptions-golf")}
            disabled={registrations.length === 0}
          >
            <Download className="h-4 w-4 mr-2" /> CSV
          </Button>
          <Button
            variant="outline"
            size="sm"
            onClick={() => exportToExcel(formatForExport(), "inscriptions-golf")}
            disabled={registrations.length === 0}
          >
            <FileSpreadsheet className="h-4 w-4 mr-2" /> Excel
          </Button>
        </div>
      </CardHeader>
      <CardContent>
        {isLoading && <p className="text-muted-foreground">Chargement...</p>}
        {error && <p className="text-destructive">Erreur : {error.message}</p>}
        {!isLoading && !error && <GolfTable registrations={registrations} />}
      </CardContent>
    </Card>
  );
};
